import { ApiError } from "@vana/core";

export class StartDeliveryError extends ApiError {}
export class FailAttemptError extends ApiError {}
export class RescheduleError extends ApiError {}
export class MoveToUndeliverableError extends ApiError {}

export class RejectByCustomerError extends ApiError {}
export class UploadEvidenceError extends ApiError {}
export class ListAddressesError extends ApiError {}
export class ListZoneOptionsError extends ApiError {}
export class GetMaxAttemptsError extends ApiError {}
